import { Dialog } from 'vnetwork-ui'
import { ModalProps } from '@/types/shared'
import ModifyObjectForm from './ModifyObjectForm'
import { ObjectType } from '@/modules/Drive/types'

export interface ModifyObjectProps extends ModalProps {
    title: string
    placeholder: string
    initialValue?: string
    source?: string
    type: ObjectType
}

const ModifyObjectModal: React.FC<ModifyObjectProps> = ({
    onClose,
    open,
    title,
    placeholder,
    initialValue,
    source,
    type,
}) => {
    return (
        <Dialog onClose={onClose} open={open} title={title}>
            <ModifyObjectForm
                onClose={onClose}
                placeholder={placeholder}
                initialValue={initialValue}
                source={source}
                type={type}
            />
        </Dialog>
    )
}

export default ModifyObjectModal
